module.exports = __webpack_public_path__ + "img/result.a41de364.png";